<div *ngIf="content" class="content-with-optional-title mb-2">
    <h2 *ngIf="title">{{ title | translate }}</h2>
    <div *ngIf="hasInnerHtml" [innerHtml]="content"></div>
    <div *ngIf="!hasInnerHtml">{{content}}</div>
</div>
